import { MainNavigatorOptionProps } from 'layouts/Scaffold/MainNavigator';
import {
  CalendarDaysIcon,
  WarehouseIcon,
  SettingsIcon,
  FileSpreadsheetIcon,
} from 'lucide-react';

export const mainNavOptions: MainNavigatorOptionProps['options'] = [
  {
    name: 'Relatórios',
    description: 'Requisite e faça download de relatórios',
    icon: <FileSpreadsheetIcon className="w-5 h-5" />,
    subOptions: [
      {
        name: 'Saldo em estoque',
        route: '/relatorios/saldo-estoque',
        permission: 'estoque',
      },
      {
        name: 'Estoque pendente de regularização',
        route: '/relatorios/estoque-pendente-regularizacao',
        permission: 'estoque',
      },
      {
        name: 'Solicitações de carregamento',
        route: '/relatorios/solicitacoes-de-carregamento',
        permission: 'agendamento',
      },
      {
        name: 'Solicitações de descarregamento',
        route: '/relatorios/solicitacoes-de-descarregamento',
        permission: 'agendamento',
      },
    ],
  },
  {
    name: 'Estoque',
    description: 'Controle de estoque e gestão de armazéns.',
    icon: <WarehouseIcon className="w-5 h-5" />,
    subOptions: [
      {
        name: 'Saldo em estoque',
        route: '/estoque/saldo-estoque',
        permission: 'estoque',
      },
      {
        name: 'Pendentes de regularização',
        route: '/estoque/pendentes-regularizacao',
        permission: 'estoque',
      },
    ],
  },
  {
    name: 'Agendamento',
    description: 'Módulo de agendamento de cargas.',
    icon: <CalendarDaysIcon className="w-5 h-5" />,
    subOptions: [
      {
        name: 'Solicitações de carregamento',
        route: '/agendamento/solicitacoes/carregamento',
        permission: 'agendamento',
      },
      {
        name: 'Solicitações de descarregamento',
        route: '/agendamento/solicitacoes/descarregamento',
        permission: 'agendamento',
      },
      {
        name: 'Solicitações Pendentes',
        route: '/agendamento/solicitacoes-pendentes',
        permission: 'agendamento',
      },
      {
        name: 'Calendário',
        route: '/agendamento/calendario',
        permission: 'agendamento',
      },
    ],
  },
  {
    name: 'Configurador',
    description: 'Módulo de configurações.',
    icon: <SettingsIcon className="w-5 h-5" />,
    subOptions: [
      {
        route: '/configuracoes/clientes',
        name: 'Clientes',
        permission: 'configuracoes',
      },
      {
        route: '/configuracoes/clientes/usuarios',
        name: 'Usuários de Clientes',
        permission: 'configuracoes',
      },
      {
        route: '/configuracoes/transportadoras',
        name: 'Transportadoras',
        permission: 'configuracoes',
      },
      {
        route: '/configuracoes/transportadoras/usuarios',
        name: 'Usuários de Transportadoras',
        permission: 'configuracoes',
      },
      {
        route: '/configuracoes/armazens',
        name: 'Armazéns',
        permission: 'configuracoes',
      },
      {
        route: '/configuracoes/armazens/usuarios',
        name: 'Usuários de Armazéns',
        permission: 'configuracoes',
      },
      {
        route: '/configuracoes/bloqueio-de-horarios',
        name: 'Bloqueio de Horários',
        permission: 'configuracoes',
      },
      {
        route: '/configuracoes/tipos-veiculos',
        name: 'Tipos de Veículos',
        permission: 'configuracoes',
      },
      {
        route: '/configuracoes/tipos-cargas',
        name: 'Tipos de Cargas',
        permission: 'configuracoes',
      },
      {
        route: '/configuracoes/setups-veiculos',
        name: 'Setups de Veículos',
        permission: 'configuracoes',
      },
      {
        route: '/configuracoes/tipos-operacoes',
        name: 'Tipos de Operações',
        permission: 'configuracoes',
      },
      {
        route: '/configuracoes/justificativas-cancelamento',
        name: 'Justificativas de Cancelamento',
        permission: 'configuracoes',
      },
      {
        route: '/configuracoes/administradores',
        name: 'Administradores',
        permission: 'configuracoes',
      },
      {
        route: '/configuracoes/motoristas',
        name: 'Motoristas',
        permission: 'configuracoes',
      },
    ],
  },
];
